import { render, staticRenderFns } from "./list.vue?vue&type=template&id=02f22ffb"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f22ffb')) {
      api.createRecord('02f22ffb', component.options)
    } else {
      api.reload('02f22ffb', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=02f22ffb", function () {
      api.rerender('02f22ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact-list/list.vue"
export default component.exports